"use strict";

// Module API

function checkPattern(constraint, value) {
  if (value === null) {
    return true;
  }
  var regex = new RegExp(constraint);
  var match = regex.exec(value);
  if (match) {
    return true;
  }
  return false;
}

module.exports = {
  checkPattern: checkPattern
};


//////////////////
// WEBPACK FOOTER
// ./~/tableschema/lib/constraints/pattern.js
// module id = 328
// module chunks = 0